var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKeyboardHide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2a1 1 0 011-1h22a1 1 0 011 1v12a1 1 0 01-1 1H1a1 1 0 01-1-1V2zm2 1v10h20V3H2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6a1 1 0 011-1h1a1 1 0 010 2H4a1 1 0 01-1-1zM8 6a1 1 0 011-1h1a1 1 0 110 2H9a1 1 0 01-1-1zM13 6a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM18 6a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM3 10a1 1 0 011-1h1a1 1 0 110 2H4a1 1 0 01-1-1zM8 10a1 1 0 011-1h6a1 1 0 110 2H9a1 1 0 01-1-1zM18 10a1 1 0 011-1h1a1 1 0 110 2h-1a1 1 0 01-1-1zM7.2 18.4a1 1 0 011.4-.2l3.4 2.55 3.4-2.55a1 1 0 011.2 1.6l-4 3a1 1 0 01-1.2 0l-4-3a1 1 0 01-.2-1.4z"
  })));
}
export default SvgKeyboardHide;